module.exports = __webpack_public_path__ + "static/media/greentick.278e4c13.svg";